/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Loading_SectionsInputs */

const en_mobile_player_loading_sections = /** @type {(inputs: Mobile_Player_Loading_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading sections…`)
};

const es_mobile_player_loading_sections = /** @type {(inputs: Mobile_Player_Loading_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando secciones…`)
};

/**
* | output |
* | --- |
* | "Loading sections…" |
*
* @param {Mobile_Player_Loading_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_loading_sections = /** @type {((inputs?: Mobile_Player_Loading_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Loading_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_loading_sections(inputs)
	return en_mobile_player_loading_sections(inputs)
});